{
  "title": "Encode Thoughts",
  "source": "Guildmaster's Guide to Ravnica",
  "levelAndSchool": "Enchantment cantrip",
  "level": 0,
  "castingTime": "1 action",
  "range": "Self",
  "components": "S",
  "duration": "8 hours",
  "description": [
    "You pull a memory, an idea, or a message from your mind and transform it into a tangible string of glowing energy called a thought strand, which persists for the duration or until you cast this spell again. The thought strand appears in an unoccupied space within 5 feet of you as a Tiny, weightless, semisolid object that can be held and carried like a ribbon. It is otherwise stationary.",
    "If you cast this spell while concentrating on a spell or an ability that allows you to read or manipulate the thoughts of others (such as detect thoughts or modify memory), you can transform the thoughts or memories you read, rather than your own, into a thought strand.",
    "Casting this spell while holding a thought strand allows you to instantly receive whatever memory, idea, or message the thought strand contains. (Casting detect thoughts on the strand has the same effect.)"
  ],
  "spellLists": ["eldritch-knight", "arcane-trickster", "wizard"]
}
